import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { IMAGES } from "@/data/site";
import { Heart } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4EBD9] px-6">
      <div className="w-full max-w-md rounded-3xl bg-[#FDFBF7] border border-[#E5DCC5] p-10 shadow-[0_20px_60px_rgba(43,45,66,0.12)]">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-12 w-12 rounded-full overflow-hidden bg-white shrink-0"><img src={IMAGES.logo} alt="logo" className="h-full w-full object-cover scale-[1.18]" /></span>
          <div>
            <p className="font-display text-xl font-bold text-[#2B2D42]">Officer Login</p>
            <p className="text-sm text-[#4A4E69]">Manage campaigns</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs font-medium uppercase tracking-wide text-[#4A4E69]">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
              className="mt-2 w-full rounded-xl border border-[#E5DCC5] bg-white px-4 py-3 text-[#2B2D42] outline-none focus:border-[#E07A5F] focus:ring-2 focus:ring-[#E07A5F]/20"
            />
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wide text-[#4A4E69]">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
              className="mt-2 w-full rounded-xl border border-[#E5DCC5] bg-white px-4 py-3 text-[#2B2D42] outline-none focus:border-[#E07A5F] focus:ring-2 focus:ring-[#E07A5F]/20"
            />
          </div>
          {error && (
            <p className="text-sm text-[#E07A5F]" data-testid="login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#E07A5F] px-6 py-3.5 font-semibold text-white transition-all hover:bg-[#D06A4F] active:scale-95 disabled:opacity-60"
          >
            <Heart className="h-4 w-4 fill-white" /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-sm text-[#4A4E69] hover:text-[#2B2D42]">← Back to site</a>
      </div>
    </div>
  );
}
